import React from 'react';

/** 沒有資料（非表格的區塊）：一行標題＋一行說明＋主要按鈕（§3-8）；表格內用 ListEmptyRow */
const EmptyPanel: React.FC<{ title: string; hint?: string; action?: React.ReactNode }> = ({ title, hint, action }) => (
  <div className="bg-surface rounded-lg border border-line px-6 py-10 text-center">
    <p className="text-sm font-medium text-fg">{title}</p>
    {hint && <p className="mt-1 text-[13px] text-fg-secondary">{hint}</p>}
    {action && <div className="mt-4 flex justify-center">{action}</div>}
  </div>
);

export default EmptyPanel;
